import React, { createContext, useState, useContext, useEffect } from 'react';
import * as companyService from '../services/company.service';

const CompanyContext = createContext(null);

export const CompanyProvider = ({ children }) => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load company details on mount (no auth needed - endpoint is public)
    const loadCompanyDetails = async () => {
      try {
        const data = await companyService.getCompanyDetails();
        if (data) {
          setCompany(data);
        }
      } catch (error) {
        console.error('Failed to load company details:', error);
        // Don't bubble up the error, just log it
      } finally {
        setLoading(false);
      }
    };

    loadCompanyDetails();
  }, []);

  const updateCompany = (newCompanyData) => {
    setCompany(newCompanyData);
  };

  return (
    <CompanyContext.Provider value={{ company, loading, updateCompany }}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};
